<template>
    <div v-if="user">
<!--        <v-btn v-if="user.profile.employment_type_raw === 'freelancer'"-->
<!--               @click="dialog = true"-->
<!--               color="primary darken-1"-->
<!--               block-->
<!--               elevation="0">-->
<!--            {{ $vuetify.lang.t('$vuetify.buttons.submit_contract') }}-->
<!--        </v-btn>-->

<!--        <v-btn v-else-->
        <v-btn color="primary darken-1"
               :to="toContract"
               block
               elevation="0"
               id="dashboard-contractclaim">
            {{ $vuetify.lang.t('$vuetify.buttons.submit_contract') }}
        </v-btn>

<!--        <v-dialog v-model="dialog"-->
<!--                  max-width="290">-->
<!--            <v-card flat-->
<!--                    tile-->
<!--                    class="mb-2 overflow-hidden nested">-->
<!--                <div class="py-3 px-3">-->
<!--                    <h2 class="mb-1 headline font-weight-bold">-->
<!--                        {{ $vuetify.lang.t('$vuetify.submit_contract_dialog.title') }}-->
<!--                    </h2>-->

<!--                    <p class="mb-2 body-1"-->
<!--                       v-html="$vuetify.lang.t('$vuetify.submit_contract_dialog.desc', user.company.name, user.company.address_city)"></p>-->

<!--                    <v-row no-gutters align="center">-->
<!--                        <v-col cols="6" class="pr-1">-->
<!--                            <v-btn block-->
<!--                                   tile-->
<!--                                   depressed-->
<!--                                   color="success"-->
<!--                                   @click="approve(approval.id)"-->
<!--                                   :to="toContract">-->
<!--                                {{ $vuetify.lang.t('$vuetify.submit_contract_dialog.agree') }}-->
<!--                            </v-btn>-->
<!--                        </v-col>-->
<!--                        <v-col cols="6" class="pl-1">-->
<!--                            <v-btn block-->
<!--                                   tile-->
<!--                                   depressed-->
<!--                                   color="error"-->
<!--                                   :to="toChangeRetailer">-->
<!--                                {{ $vuetify.lang.t('$vuetify.submit_contract_dialog.disagree') }}-->
<!--                            </v-btn>-->
<!--                        </v-col>-->
<!--                    </v-row>-->
<!--                </div>-->

<!--            </v-card>-->
<!--        </v-dialog>-->
    </div>
</template>
<script>
    // utils
    import {
        ROUTE_CHANGE_RETAILER,
        ROUTE_SUBMIT_CONTRACT
    } from '../utils/constants';

    export default {
        name: 'submit-contract-link-btn',
        props: {
            user: {
                required: true,
            },
        },
        computed: {
            toContract() {
                return { name: ROUTE_SUBMIT_CONTRACT };
            },
            toChangeRetailer() {
                return { name: ROUTE_CHANGE_RETAILER };
            },
        },
        data() {
            return {
                dialog: false,
            };
        },
    };
</script>
